import { Spinner, ThemeProvider } from '@alphonsocode/kallos';
import React from 'react';
import { LastFetchedStyle } from './style';
import { BsSearch } from 'react-icons/bs';
import { MdOutlineRefresh } from 'react-icons/md';
import { track } from 'analytics/posthog';
import useQuery from 'reusable/customHooks/useQuery';

function LastFetched({ refetch, lastFetchedTime, isFetching }) {
  const [query] = useQuery();
  const formattedTime = lastFetchedTime
    ? new Date(lastFetchedTime).toLocaleString('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      })
    : ''; //convert time from epoch to "Fri, Feb 21, 2025 3:46 PM" format
  return (
    <LastFetchedStyle>
      <div className="lastFetchedDiv">
        <label className="spacer">&nbsp;</label>
        <div className="lastFetchedRow">
        {/* @ts-ignore - ThemeProvider children type issue with React 18 */}
        <ThemeProvider defaultMode="light">
          <label className="heading">Last Fetched:</label>
          {isFetching ? (
            <Spinner
              className="spinner"
              animation={'border'}
            />
          ) : (
            <>
              <label className="time"> {formattedTime}</label>
              <MdOutlineRefresh
                className="refreshIcon"
                onClick={() => {
                  track('adsure refresh clicked', {
                    adsure_test_tag: query.get('testTag') || 'cta',
                    my_campaigns: query.get('myCampaigns') === 'true',
                    my_tests: query.get('myTests') === 'true',
                    surface: 'adsure',
                  });
                  refetch();
                }}
              />
            </>
          )}
        </ThemeProvider>
        </div>
      </div>
    </LastFetchedStyle>
  );
}

export default LastFetched;
